import Vuex from 'vuex';
import { createHelpers } from 'vuex-map-fields';

Vue.use(Vuex);

const { getFieldsSolicitudes, updateFieldsSolicitudes } = createHelpers({
  getterType: 'getFieldsSolicitudes',
  mutationType: 'updateFieldsSolicitudes',
});

export default {
  namespaced: true,
  state: {
    solicitudes: [],
  },
  mutations: {
    updateFieldsSolicitudes,
  },
  getters: {
    getFieldsSolicitudes,
  },
};
